// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IRequisitesDto } from './IRequisitesDto';
import {
    IRequisitesDtoFromJSON,
    IRequisitesDtoFromJSONTyped,
    IRequisitesDtoToJSON,
    IRequisitesDtoToJSONTyped,
} from './IRequisitesDto';
import type { ITransferDetailsDto } from './ITransferDetailsDto';
import {
    ITransferDetailsDtoFromJSON,
    ITransferDetailsDtoFromJSONTyped,
    ITransferDetailsDtoToJSON,
    ITransferDetailsDtoToJSONTyped,
} from './ITransferDetailsDto';
import type { IPaymentAddressResponseDto } from './IPaymentAddressResponseDto';
import {
    IPaymentAddressResponseDtoFromJSON,
    IPaymentAddressResponseDtoFromJSONTyped,
    IPaymentAddressResponseDtoToJSON,
    IPaymentAddressResponseDtoToJSONTyped,
} from './IPaymentAddressResponseDto';

/**
 * 
 * @export
 * @interface IPaymentDetailsResponseDto
 */
export interface IPaymentDetailsResponseDto {
    /**
     * 
     * @type {string}
     * @memberof IPaymentDetailsResponseDto
     */
    payment_type?: IPaymentDetailsResponseDtoPaymentTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IPaymentDetailsResponseDto
     */
    payment_method_type?: IPaymentDetailsResponseDtoPaymentMethodTypeEnum;
    /**
     * 
     * @type {IRequisitesDto}
     * @memberof IPaymentDetailsResponseDto
     */
    payment_requisites?: IRequisitesDto;
    /**
     * 
     * @type {IPaymentAddressResponseDto}
     * @memberof IPaymentDetailsResponseDto
     */
    payment_address?: IPaymentAddressResponseDto;
    /**
     * 
     * @type {string}
     * @memberof IPaymentDetailsResponseDto
     */
    pay_to?: string;
    /**
     * 
     * @type {Array<ITransferDetailsDto>}
     * @memberof IPaymentDetailsResponseDto
     */
    transfers?: Array<ITransferDetailsDto>;
    /**
     * 
     * @type {string}
     * @memberof IPaymentDetailsResponseDto
     */
    verification_status?: IPaymentDetailsResponseDtoVerificationStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof IPaymentDetailsResponseDto
     */
    account_id?: number;
}

/**
* @export
* @enum {string}
*/
export enum IPaymentDetailsResponseDtoPaymentTypeEnum {
    REIMBURSEMENT = 'REIMBURSEMENT',
    BILL_PAY = 'BILL_PAY',
    CARD_SWIPE = 'CARD_SWIPE'
}
/**
* @export
* @enum {string}
*/
export enum IPaymentDetailsResponseDtoPaymentMethodTypeEnum {
    DIRECT_DEPOSIT = 'DIRECT_DEPOSIT',
    DEBIT = 'DEBIT',
    VENMO = 'VENMO',
    PAYPAL = 'PAYPAL',
    CHECK = 'CHECK'
}
/**
* @export
* @enum {string}
*/
export enum IPaymentDetailsResponseDtoVerificationStatusEnum {
    PENDING = 'PENDING',
    PENDING_MANUAL = 'PENDING_MANUAL',
    VERIFIED = 'VERIFIED',
    VERIFICATION_FAILED = 'VERIFICATION_FAILED',
    EXPIRED = 'EXPIRED'
}


/**
 * Check if a given object implements the IPaymentDetailsResponseDto interface.
 */
export function instanceOfIPaymentDetailsResponseDto(value: object): value is IPaymentDetailsResponseDto {
    return true;
}

export function IPaymentDetailsResponseDtoFromJSON(json: any): IPaymentDetailsResponseDto {
    return IPaymentDetailsResponseDtoFromJSONTyped(json, false);
}

export function IPaymentDetailsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IPaymentDetailsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'payment_type': json['payment_type'] == null ? undefined : json['payment_type'],
        'payment_method_type': json['payment_method_type'] == null ? undefined : json['payment_method_type'],
        'payment_requisites': json['payment_requisites'] == null ? undefined : IRequisitesDtoFromJSON(json['payment_requisites']),
        'payment_address': json['payment_address'] == null ? undefined : IPaymentAddressResponseDtoFromJSON(json['payment_address']),
        'pay_to': json['pay_to'] == null ? undefined : json['pay_to'],
        'transfers': json['transfers'] == null ? undefined : ((json['transfers'] as Array<any>).map(ITransferDetailsDtoFromJSON)),
        'verification_status': json['verification_status'] == null ? undefined : json['verification_status'],
        'account_id': json['account_id'] == null ? undefined : json['account_id'],
    };
}

export function IPaymentDetailsResponseDtoToJSON(json: any): IPaymentDetailsResponseDto {
    return IPaymentDetailsResponseDtoToJSONTyped(json, false);
}

export function IPaymentDetailsResponseDtoToJSONTyped(value?: IPaymentDetailsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'payment_type': value['payment_type'],
        'payment_method_type': value['payment_method_type'],
        'payment_requisites': IRequisitesDtoToJSON(value['payment_requisites']),
        'payment_address': IPaymentAddressResponseDtoToJSON(value['payment_address']),
        'pay_to': value['pay_to'],
        'transfers': value['transfers'] == null ? undefined : ((value['transfers'] as Array<any>).map(ITransferDetailsDtoToJSON)),
        'verification_status': value['verification_status'],
        'account_id': value['account_id'],
    };
}

